"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleMonthPicker = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var SingleMonthPickerUtils_1 = require("./SingleMonthPickerUtils");
var Select_1 = require("../Select");
exports.SingleMonthPicker = function (_a) {
    var _b;
    var startDate = _a.startDate, endDate = _a.endDate, menuPortalTarget = _a.menuPortalTarget, onChange = _a.onChange;
    var options = SingleMonthPickerUtils_1.getMonthOptions(startDate, endDate);
    var _c = react_1.useState((_b = options[0]) !== null && _b !== void 0 ? _b : null), value = _c[0], setValue = _c[1];
    var onChangeSelect = react_1.useCallback(function (selectedOption) {
        setValue(selectedOption);
        onChange(selectedOption);
    }, [onChange]);
    return (react_1.default.createElement(Select_1.Select, { options: options, value: value, onChange: onChangeSelect, highlightOptionText: true, menuPortalTarget: menuPortalTarget }));
};
